import type {
  LoginRequest,
  LoginResponse,
  SwitchOrgRequest,
  UserProfile,
} from '@todo/shared';
import { post, get } from './client';
import { deviceInfo } from '../lib/device';

/**
 * Typed wrappers around the auth endpoints.
 *
 * This is the pattern every module follows: one file per API area, each
 * function a thin, typed call. Components import these, never `api` directly,
 * so a URL change happens in exactly one place.
 */

export const authApi = {
  /** POST /api/auth/login - the device details ride along so the API can
   *  record WHERE this session started (platform WEB from the browser). */
  login(credentials: LoginRequest): Promise<LoginResponse> {
    return post<LoginResponse>('/auth/login', {
      ...credentials,
      device: credentials.device ?? deviceInfo(),
    });
  },

  /** GET /api/auth/me - also the "is my stored token still good?" check. */
  me(): Promise<UserProfile> {
    return get<UserProfile>('/auth/me');
  },

  /** POST /api/auth/switch-org - fresh tokens for another organisation the
   *  signed-in account belongs to. Same response shape as login. */
  switchOrg(body: SwitchOrgRequest): Promise<LoginResponse> {
    return post<LoginResponse>('/auth/switch-org', body);
  },
};
